export default "__VITE_ASSET__EMfali9u__"